import React from 'react';
import { Mail, MapPin } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (e, href, path) => {
    e.preventDefault();
    
    if (path === '/team' || path === '/pi') {
      navigate(path);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector(href);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const footerLinks = [
    { name: 'Home', href: '#home', path: '/' },
    { name: 'Research Areas', href: '#research', path: '/' },
    { name: 'PI', href: '/pi', path: '/pi' },
    { name: 'Our Team', href: '/team', path: '/team' },
    { name: 'Publications', href: '#publications', path: '/' },
    { name: 'Funding Sources', href: '#funding', path: '/' },
    { name: 'Join Us', href: '#recruitment', path: '/' },
    { name: 'Collaborators', href: '#collaborators', path: '/' },
    { name: 'Contact Us', href: '#contact', path: '/' }
  ];

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">The Chaturvedi Lab</h3>
            <p className="text-slate-300 leading-relaxed text-sm md:text-base">
              <span className="gradient-text-energy font-bold">Systems, Synthetic & Quantitative Biology Lab</span> at UC Riverside. 
              Engineering the future of medicine through innovative research.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-1">
              {footerLinks.map((link) => (
                <li key={link.name}>
                  <button
                    onClick={(e) => handleNavigation(e, link.href, link.path)}
                    className="text-slate-300 hover:text-emerald-400 transition-colors text-left text-sm md:text-base py-2"
                    style={{ minHeight: '44px' }}
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg md:text-xl font-bold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Mail className="h-4 w-4 md:h-5 md:w-5 mr-2 md:mr-3 mt-0.5 text-emerald-400 flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="text-slate-300 hover:text-emerald-400 transition-colors text-sm md:text-base break-all">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-start">
                <MapPin className="h-4 w-4 md:h-5 md:w-5 mr-2 md:mr-3 mt-0.5 text-emerald-400 flex-shrink-0" />
                <span className="text-slate-300 text-sm md:text-base">
                  {contactInfo.address}<br />
                  {contactInfo.city}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-700 mt-8 pt-8 text-center">
          <p className="text-slate-400 text-sm md:text-base">
            © {new Date().getFullYear()} The Chaturvedi Lab, UC Riverside. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
